export const validateDesgasteIcon = (codigo) => {
  const fourLetter = codigo.substring(3, 4);

  return fourLetter === 'D';
};
